/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { appCardStyle, appIconsPath, appLinkSize, appLinkStyle } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { Link } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import './CardSupportGeneric.scss';

export function CardSupportGeneric({
  cardStyle = appCardStyle.DEFAULT,
  cardIcon = null,
  cardTitle = '',
  text = '',
  helplineNumber = ''
}) {
  const [isCardOpen, setIsCardOpen] = useState(false);

  return (
    <div className={`${cardStyle} p-16 rounded`}>
      <div className="d-flex justify-content-between gap-12 cursor-pointer" onClick={() => setIsCardOpen(!isCardOpen)}>
        <div className="d-flex align-items-center justify-content-start gap-12">
          <img src={cardIcon} alt="card-icon" height={24} />
          <div className="pe-40">
            {tA11y(cardTitle).isHtml ? (
              <div
                className="ek-copy-sm-14-semibold"
                dangerouslySetInnerHTML={{ __html: tA11y(cardTitle).content }}
              />
            ) : (
              <div className="ek-copy-sm-14-semibold">{tA11y(cardTitle).content}</div>
            )}
          </div>
        </div>
        <button
          type="button"
          className="bg-transparent border-0"
          onClick={() => setIsCardOpen(!isCardOpen)}>
          <img
            src={isCardOpen ? appIconsPath.ARROW_UP : appIconsPath.ARROW_DOWN}
            alt="card-icon"
            height={16}
          />
        </button>
      </div>

      {isCardOpen && (
        <>
          {tA11y(text).isHtml ? (
            <div
              className="my-12 ek-labeltext-12-medium"
              dangerouslySetInnerHTML={{ __html: tA11y(text).content }}
            />
          ) : (
            <div className="my-12 ek-labeltext-12-medium">{tA11y(text).content}</div>
          )}
          <Link
            label={helplineNumber}
            linkStyle={appLinkStyle.PRIMARY}
            linkSize={appLinkSize.DEFAULT}
            {...(tA11y(helplineNumber).url && { 'href': tA11y(helplineNumber).url })}
          />
        </>
      )}
    </div>
  );
}

export default CardSupportGeneric;
